/**
 * 公共开放接口
 * **/

const publicApi = {
  // 获取基本信息
  GetBasicInfo:'/Device/GetBasicInfo',
  //用户登录
  Login: '/Login/Login',
  //获取验证码
  GetCode:'/Login/ShowValidateCode',
  //退出登录
  Logout:'/Login/Logout',
  //修改密码
  EditPwd:'/Login/EditPwd',
  //查询设备信息
  GetDeviceInfo: '/DeviceData/GetList',
  //发送任务
  SendTask: '/Device/SendTask',
  //读取设备信息
  ReadData: '/Device/ReadData',
  //获取设备信息
  GetDeviceMsg:'/Device/GetInfo',
  //获取配置登录链接
  GetConfigUrl:'/Device/GetConfigUrl',
  //获取应用类型列表
  GetAppList:'/AppInfo/GetList',
  //获取字典
  GetDict:'/SysDictionary/GetDictionary',
  //数据库升级
  UpgradeDB:'/Device/UpgradeDB',
  //获取任务结果
  GetTask:'/TaskLog/GetInfo',
  //检测记录    GwAutoCheck/GetList
  GwAutoCheck:'/GwAutoCheck/GetList',
  // 告警记录
  DeviceWarn:'/DeviceWarn/GetList',
  // 恢复历史
  Resume:'/TaskLog/Resume',
  // 数据库压缩
  CompressDb:'/Device/CompressDb',
  // 配置导入
  CopyDb:'/Device/CopyDb',
  // 数据库下载
  DownloadConfig:'/Device/DownloadConfig',
  //数据库上传
  UploadConfig:'/Device/UploadConfig',



}

export default publicApi
